module.exports = __webpack_public_path__ + "media/pick_three.702a4db3.mp3";